import { EMAIL } from "@/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-olive text-cream/50 border-t border-cream/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <span className="font-serif text-lg text-cream/80" data-testid="footer-brand">Ophelia Yoga</span>
      <a
        data-testid="footer-email"
        href={`mailto:${EMAIL}`}
        className="link-underline text-xs uppercase tracking-[0.2em] hover:text-cream transition-colors duration-300"
      >
        {EMAIL}
      </a>
      <span className="text-xs uppercase tracking-[0.2em]" data-testid="footer-copyright">
        © 2026 Ophelia Yoga · Bath, UK
      </span>
    </div>
  </footer>
);
